import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';
import App from './containers/App';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {createMuiTheme} from 'material-ui/styles';
import './index.css';

// use default theme
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#258383',
            contrastText: '#FFF',
        },
        secondary: {
            main: '#FFF',
            contrastText: '#000',
        },
    },
    typography: {
        button: {
            textTransform: 'none',
            fontWeight: 500,
            fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`
        }
    }
});

ReactDOM.render(
    <Provider store={store}>
        <MuiThemeProvider theme={theme}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </MuiThemeProvider>
    </Provider>,

    document.getElementById('root')
);
